import api from '../api';

export const dataReviewer = api.injectEndpoints({
  endpoints: builder => ({
    fetchSourceNames: builder.query({
      query: () => ({
        url: '/api/cms/question/getallquestionsourcenames',
        method: 'GET'
      })
    }),
    getIsUnderReview: builder.mutation({
      query: payload => ({
        url: '/api/cms/question/getalluploadquestions',
        method: 'POST',
        body: payload
      })
    }),
    updateQuestionStatus: builder.mutation({
      query: payload => ({
        url: '/api/cms/updatequestionstatus',
        method: 'PUT',
        body: payload
      })
    }),
    updateQuestion: builder.mutation({
      query: ({ payload, questionId }) => ({
        url: '/api/cms/update',
        method: 'PUT',
        body: payload,
        params: { questionId }
      })
    }),
    fetchReports: builder.query({
      query: payload => ({
        url: '/api/cms/reports/fetchreports',
        method: 'GET'
      })
    }),
    fetchTopicsBySection: builder.query({
      query: ({ sectionId }) => ({
        url: '/api/topic/fetch/cms/bysection',
        method: 'GET',
        params: { sectionId }
      })
    }),
    fetchQuestionTypes: builder.query({
      query: () => ({
        url: '/api/questiontype/fetchall',
        method: 'GET'
      })
    }),
    getAllCmsSectionsData: builder.query({
      query: () => ({
        url: '/api/section/fetch/cms/section',
        method: 'GET'
      })
    })
  })
});

export const {
  useFetchSourceNamesQuery,
  useGetIsUnderReviewMutation,
  useUpdateQuestionStatusMutation,
  useUpdateQuestionMutation,
  useFetchReportsQuery,
  useLazyFetchTopicsBySectionQuery,
  useFetchQuestionTypesQuery,
  useGetAllCmsSectionsDataQuery
} = dataReviewer;
